export default "/images/framework/ToWebEng.f93f9ffa.svg?f93f9ffa";